module.exports = __webpack_public_path__ + "img/3_21.c40bf9df.png";